<template>
  <n-radio-group
    :value="modelValue"
    :disabled="disabled"
    @update:value="(value) => emit('update:modelValue', value)"
  >
    <n-space>
      <n-radio
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </n-radio>
    </n-space></n-radio-group
  >
</template>

<script setup lang="ts">
interface RadioOptions {
  label: string
  value: any
  disabled?: boolean
}
// 定义Emits接口
interface RadioFieldEmits {
  (
    e: 'update:modelValue',
    value: string | number | boolean | (string | number | boolean)[] | undefined
  ): void
  (
    e: 'change',
    value: string | number | boolean | (string | number | boolean)[] | undefined
  ): void
}
const props = defineProps<{
  modelValue: string | number | undefined
  disabled?: boolean
  [key: string]: any
  options: RadioOptions[]
}>()

const emit = defineEmits<RadioFieldEmits>()
</script>
